import { StorageManager } from '../../../common/storage-manager.class';
import { environment } from '../../../../environments/environment';

export class GenerateEnvironmentDefinition {
  public appName = environment.appName;

  public codigoINE = environment.features.codigoINE;

  public serverUrl = environment.serverUrl;

  public sectorName = environment.features.sectorName;

  public user = StorageManager.getUser();

  public showFincasInformeTratamientos = environment.features.showFincasInformeTratamientos;

  public showFincasLibroFertilizantes = environment.features.showFincasLibroFertilizantes;

  public showTareasMto = environment.features.showTareasMto;

  public wizard = environment.features.welcomeWizard;
}// class;